module.exports = __webpack_public_path__ + "img/special-offer-icon.svg";